import { render } from "./ActiveData.vue?vue&type=template&id=dcf20828&scoped=true"
import script from "./ActiveData.vue?vue&type=script&lang=js"
export * from "./ActiveData.vue?vue&type=script&lang=js"

import "./ActiveData.vue?vue&type=style&index=0&id=dcf20828&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcf20828"]])

export default __exports__